import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpService } from './http.service';

@Injectable({
    providedIn: 'root'
})
export class CnpjService {

    constructor(
        private http: HttpClient,
        private httpService: HttpService
    ) { }

    public searchCnpj(cnpj: string, subject: Subject<any>) {

        this.http.get(`https://admin4.colloca.com.br/api/campaign/find-cnpj?cnpj=${cnpj}`)
            .subscribe(
                (result: any) => {
                    subject.next(result);
                },
                (err: any) => {
                    console.error(err);
                    subject.error(err);
                }
            )

    }

    public updateCnpj(email: string) {

        this.httpService.save('profile:signature_status', { email })
            .subscribe()

    }

}
